import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'bn',
    fullName: 'Bangla',
    nativeName: 'বাংলা',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "কিছু আশ্চর্যজনক আসছে",
    landing_subtitle: "ArgVoid একটি অ্যাপ এবং গেম ডেভেলপমেন্ট স্টুডিও। সাথে থাকুন, নতুন জিনিস শীঘ্রই আসছে!",
    select_language: "ভাষা নির্বাচন করুন",
    search_placeholder: "ভাষা অনুসন্ধান করুন...",
    terms_title: "পরিষেবার শর্তাবলী",
    policy_title: "গোপনীয়তা নীতি",
    cookies_title: "কুকি নীতি",
    terms_content: `
        <strong>1। শর্তাদি </strong><br> এর গ্রহণযোগ্যতা
        ArgVoid অ্যাক্সেস করে, এই পরিষেবার শর্তাবলী গৃহীত হয়। এই শর্তাবলীতে সম্মত না হলে, পরিষেবাটি ব্যবহার করা উচিত নয়৷<br><br>৷

        <strong>2। প্ল্যাটফর্মের ব্যবহার</strong><br>
        ArgVoid এবং এর অ্যাপ্লিকেশনগুলি তথ্য ও সৃজনশীল উদ্দেশ্যে "যেমন আছে" প্রদান করা হয়৷ পরিষেবাটি শুধুমাত্র বৈধ উদ্দেশ্যে ব্যবহার করা আবশ্যক৷<br><br>৷

        <strong>3। নিষিদ্ধ আচরণ</strong><br>
        সাইটের দুর্বলতা, স্প্যামিং বা অবকাঠামোতে অননুমোদিত অ্যাক্সেসের চেষ্টা করা কঠোরভাবে নিষিদ্ধ৷<br><br>

        <strong>4। দাবিত্যাগ</strong><br>
        প্ল্যাটফর্ম এবং পরিষেবাগুলি যে কোনও সময় বিজ্ঞপ্তি ছাড়াই সংশোধন করা যেতে পারে৷ পরিষেবার আপটাইম বা প্রাপ্যতা সম্পর্কিত কোনও ওয়ারেন্টি দেওয়া হয় না।
    `,
    policy_content: `
        <strong>1। তথ্য সংগ্রহ</strong><br>
        প্ল্যাটফর্মটির এই সময়ে ব্যবহারকারীর প্রমাণীকরণ বা অ্যাকাউন্ট তৈরির প্রয়োজন নেই। কোনো ব্যক্তিগত সনাক্তকরণ তথ্য (যেমন নাম বা ইমেল ঠিকানা) সক্রিয়ভাবে দর্শকদের কাছ থেকে সংগ্রহ করা হয় না।<br><br>

        <strong>2। ডেটাএক্স6X<br> ব্যবহার
        বেসিক, বেনামী বিশ্লেষণ সাইট ট্র্যাফিক বুঝতে এবং অ্যাপ্লিকেশন উন্নত করতে সংগ্রহ করা হতে পারে। এই ডেটা পৃথক ব্যবহারকারী পরিচয়ের সাথে লিঙ্ক করা হয় না৷<br><br>৷

        <strong>3। তৃতীয় পক্ষের পরিষেবা </strong><br>৷
        তৃতীয় পক্ষের প্রদানকারী হোস্টিং এবং বিশ্লেষণ পরিষেবার জন্য ব্যবহার করা যেতে পারে। এই সংশ্লিষ্ট প্রদানকারীদের গোপনীয়তা অনুশীলনগুলি তাদের অবকাঠামোতে প্রক্রিয়া করা বেনামী ডেটা পরিচালনা করে৷<br><br>

        <strong>4। ডেটা নিরাপত্তা</strong><br>
        প্ল্যাটফর্ম রক্ষা করার জন্য যুক্তিসঙ্গত নিরাপত্তা ব্যবস্থা প্রয়োগ করা হয়। যাইহোক, ইন্টারনেটের মাধ্যমে সংক্রমণের কোনো পদ্ধতিই সম্পূর্ণ নিরাপদ নয়।<br><br>
    `,
    cookies_content: `
        <strong>1। কুকিজ এবং স্থানীয় স্টোরেজ কি?</strong><br>
        কুকি এবং ব্রাউজার স্থানীয় সঞ্চয়স্থান হল ছোট ডেটা ফাইল যা ডিভাইসে সংরক্ষিত থাকে যাতে ভিজিট জুড়ে কনফিগারেশন পছন্দগুলি মনে রাখা যায়।<br><br>

        <strong>2। ব্যবহারের উদ্দেশ্য</strong><br>
        ব্রাউজার লোকালস্টোরেজ কনফিগারেশন সেটিংস সংরক্ষণ করতে কঠোরভাবে ব্যবহার করা হয়, যেমন:<br>
        - ভাষার পছন্দ <br>
        - ইউজার ইন্টারফেস কনফিগারেশন (যেমন, লেআউট বা থিম সেটিংস)<br>
        - অস্থায়ী অ্যাপ্লিকেশন cache<br><br>

        <strong>3। কোন Tracking</strong><br> নেই
        কুকিজ এবং স্থানীয় স্টোরেজ বিজ্ঞাপন বা তৃতীয় পক্ষের ট্র্যাকিং উদ্দেশ্যে ব্যবহার করা হয় না। সমস্ত সঞ্চিত ডেটা প্ল্যাটফর্মের মূল কার্যকারিতার জন্য কঠোরভাবে৷<br><br>৷

        <strong>4। Control</strong><br>
        ব্রাউজার ডেটা ব্রাউজার সেটিংসের মাধ্যমে যেকোনো সময় সাফ করা যেতে পারে, যা যেকোনো স্থানীয় কনফিগারেশন রিসেট করবে।
    `,
    cookie_consent_text: "ওয়েবসাইটের কার্যকারিতা সঠিকভাবে নিশ্চিত করতে আমরা মৌলিক কুকি ব্যবহার করি, যেমন আপনার সেশন সক্রিয় রাখা, আপনার ভাষা পছন্দ সংরক্ষণ করা এবং অন্যান্য কাস্টম কনফিগারেশন।",
    read_policy: "কুকি নীতি পড়ুন",
    support_title: "সহায়তার সাথে যোগাযোগ করুন",
    support_subject_label: "বিষয়",
    support_message_label: "বার্তা",
    support_submit_button: "বার্তা পাঠান",
    support_hint: "দ্রষ্টব্য: এটি বার্তা পাঠানোর জন্য আপনার ডিফল্ট ইমেল অ্যাপ্লিকেশন খুলবে।",
    support_success_msg: "আপনার ইমেল অ্যাপ খোলা হচ্ছে...",
    support_error_msg: "বার্তা পাঠাতে ব্যর্থ হয়েছে. পরে আবার চেষ্টা করুন.",
    explorer_title: "এক্সপ্লোরার",
    history_title: "ইতিহাস",
    animation_title: "অ্যানিমেশন",
    config_title: "কনফিগারেশন",
    tool_mouse: "নির্বাচন করুন (Ctrl+M)",
    tool_brush: "ব্রাশ (Ctrl+B)",
    tool_brush_mode: "টগল মোড (সলিড/ক্লিয়ার)",
    tool_eraser: "ইরেজার (Ctrl+E)",
    tool_brush_size: "ব্রাশের আকার সামঞ্জস্য করুন",
    tool_bucket: "পূরণ করুন (Ctrl+F)",
    tool_eyedropper: "আইড্রপার",
    tool_grid: "গ্রিড (Ctrl+Shift+B)",
    tool_rotate: "ঘোরান (Ctrl+Shift+R)",
    tool_flip_h: "ফ্লিপ H (Ctrl+Shift+H)",
    tool_flip_v: "ফ্লিপ V (Ctrl+Shift+V)",
    tool_transpose: "স্থানান্তর (Ctrl+Shift+T)",
    label_width: "প্রস্থ",
    label_height: "উচ্চতা",
    label_frames: "ফ্রেমের সংখ্যা",
    label_animation: "অ্যানিমেশন স্টাইল",
    label_background_color: "পটভূমির রঙ",
    label_interval: "ব্যবধান",
    tool_anim_config: "অ্যানিমেশন কনফিগারেশন",
    label_new_width: "নতুন প্রস্থ",
    label_new_height: "নতুন উচ্চতা",
    label_apply: "আবেদন করুন",
    label_colors: "রং",
    label_size: "আকার",
    label_tolerance: "সহনশীলতা",
    val_horizontal: "অনুভূমিক",
    val_vertical: "উল্লম্ব",
    val_sequence: "সিকোয়েন্স",
    val_bounce: "বাউন্স",
    val_random: "এলোমেলো",
    val_solid: "কঠিন",
    val_clear: "পরিষ্কার",
    action_add_sheet: "নতুন পত্রক",
    action_import: "আমদানি",
    action_export: "রপ্তানি",
    action_sort_projects: "সাজান",
    sort_date_old: "প্রাচীনতম প্রথম",
    sort_date_new: "নতুন প্রথম",
    sort_name_az: "নাম (A-Z)",
    sort_name_za: "নাম (Z-A)",
    action_new_sprite: "নতুন স্প্রাইট",
    action_new_project: "নতুন প্রকল্প",
    modal_save_all_title: "সমস্ত পরিবর্তন সংরক্ষণ করুন",
    modal_save_all_desc: "সংরক্ষণ করতে সম্পদ নির্বাচন করুন:",
    modal_save_selected: "নির্বাচিত সংরক্ষণ করুন",
    action_saved: "সংরক্ষিত",
    modal_create_sprite_title: "নতুন স্প্রাইট তৈরি করুন",
    modal_create_project_title: "নতুন প্রকল্প তৈরি করুন",
    modal_add_sheet_title: "নতুন পত্রক যোগ করুন",
    modal_rename_sheet_title: "পত্রক পুনঃনামকরণ করুন",
    modal_rename_sprite_title: "স্প্রাইট নাম পরিবর্তন করুন",
    modal_delete_sprite_title: "স্প্রাইট মুছুন",
    modal_delete_project_title: "প্রকল্প মুছুন",
    modal_delete_sheet_title: "শীট মুছুন",
    placeholder_sprite_name: "নাম",
    placeholder_project_name: "নাম",
    placeholder_sheet_name: "নাম",
    placeholder_new_name: "নতুন নাম",
    action_create: "তৈরি করুন",
    action_add: "যোগ করুন",
    action_rename: "নাম পরিবর্তন করুন",
    action_duplicate: "ডুপ্লিকেট",
    action_delete: "মুছে দিন",
    action_cancel: "বাতিল করুন",
    confirm_delete_sprite: "আপনি কি নিশ্চিত আপনি এই পরকীয়া মুছে ফেলতে চান?",
    confirm_delete_project: "আপনি কি এই প্রকল্পটি মুছে ফেলার বিষয়ে নিশ্চিত? সব sprites মুছে ফেলা হবে.",
    confirm_delete_sheet: "আপনি কি এই পত্রকটি মুছতে চান?",
    err_select_sprite: "প্রথমে একটি পরী নির্বাচন করুন.",
    err_select_project: "প্রথমে একটি প্রকল্প নির্বাচন করুন.",
    err_name_empty: "নাম খালি রাখা যাবে না।",
    err_sprite_exists: "এই নামের একটি স্প্রাইট ইতিমধ্যেই বিদ্যমান।",
    err_project_exists: "এই নামের একটি প্রকল্প ইতিমধ্যেই বিদ্যমান৷",
    err_no_content: "সংরক্ষণ করার জন্য কোন বিষয়বস্তু নেই।",
    err_no_changes: "সংরক্ষণ করার জন্য কোন পরিবর্তন নেই।",
    err_delete_last_sheet: "শেষ শীট মুছে ফেলা যাবে না.",
    err_extract_frames: "কোনো ফ্রেম বের করা যায়নি।",
    err_indexeddb: "স্থানীয়ভাবে সংরক্ষণ করতে ব্যর্থ হয়েছে. আপনার ব্রাউজার IndexedDB সমর্থন নাও করতে পারে।",
    msg_upload_success: "আপলোড সফল হয়েছে: {0}",
    msg_upload_failed: "আপলোড ব্যর্থ হয়েছে: {0}",
    msg_save_success: "সফলভাবে সংরক্ষণ করুন।",
    msg_saving: "সংরক্ষণ করা হচ্ছে...",
    msg_multi_save_result: "সংরক্ষিত {0}টি সম্পদ। {1} ব্যর্থতা।",
    menu_title: "মেনু",
    menu_save: "সংরক্ষণ করুন",
    menu_save_all: "সব সংরক্ষণ করুন",
    menu_support: "সহায়তার সাথে যোগাযোগ করুন",
    label_local_storage: "স্থানীয় স্টোরেজ",
    label_sign_in: "সাইন ইন করুন",
    modal_export_title: "রপ্তানি স্প্রাইট",
    label_filename: "ফাইলের নাম",
    label_format: "বিন্যাস",
    action_export_confirm: "রপ্তানি",
};

export default translations;
